import {
  fetchRateMarketingInputs,
  addOrUpdateRateMarketingInputs,
} from 'actions/rateMarketingInputs';

const rateMarketingInputs = () => {
  const initialState = {
    inputs: [],
    isSuccessful: false,
  };

  return (state = initialState, { type, response }) => {
    switch (type) {
      case fetchRateMarketingInputs.requestTypes.SUCCESS:
        return {
          ...state,
          inputs: response,
        };

      case addOrUpdateRateMarketingInputs.requestTypes.SUCCESS:
        return {
          ...state,
          isSuccessful: true,
        };

      case addOrUpdateRateMarketingInputs.requestTypes.FAILURE:
        return {
          ...state,
          isSuccessful: false,
        };

      default:
        return state;
    }
  };
};

export default rateMarketingInputs();
